module.exports = __webpack_public_path__ + "static/img/icon_n.567cc419.png";